import { useI18n } from '@change-corgi/core-react/i18n';

import type { PaymentType } from '#src/app/shared/utils/payments';

import { usePromoteFormData } from '../../../../formContext/formData';

export function useLineItemDescription(): (paymentType: PaymentType) => string {
	const { petition } = usePromoteFormData();
	const { translate } = useI18n();
	return function lineItemDescription(paymentType) {
		if (paymentType === 'paypal') {
			// TODO: move i18n key to corgi namespace
			return translate('fe.components.paypal.line_item_description.promotion', {
				petition_title: petition.displayTitle,
			});
		}
		return `Promoted petition: ${petition.id}`;
	};
}
